<template>
  <div class="home">
    <div class="main-info">
      <Logo />
      <SocialLinks />
    </div>
    
    <div class="taur-picture">
      <img src="../assets/taur_hs_large.jpg" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Logo from '../components/Logo.vue'
import SocialLinks from '../components/SocialLinks.vue'

export default defineComponent({
  name: 'Home',
  components: {
    Logo,
    SocialLinks,
  },
})
</script>

<style lang="scss">
.home {
  position: relative;
  text-align: left;
  overflow: hidden;

  .main-info {
    overflow: hidden;
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: center;
    margin-left: 10%;

    
      margin: 0;
      align-items: center;
      position: fixed;
      bottom: 0;
      width: 100%;

      img {
        width: 300px;
      }
    
  }

  .taur-picture {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: -1;

    img {
      height: 100vh;
      width: 100vw;
      object-fit: cover;
    }
  }
}
</style>
